var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("GroupsForSurvey", {
        ref: "groups",
        attrs: {
          remote: _vm.remote,
          advanceRegistration: true,
          allowNoEmailForExternalUsers: true
        },
        scopedSlots: _vm._u([
          {
            key: "editModalTitle",
            fn: function() {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.$t("survey.advanceRegistration.editModal.title")
                    ) +
                    "\n    "
                )
              ]
            },
            proxy: true
          },
          {
            key: "actionsBefore",
            fn: function({ group }) {
              return [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-sm btn-warning",
                    on: {
                      click: function($event) {
                        return _vm.$refs.userPresenceModal.open(group)
                      }
                    }
                  },
                  [_c("i", { staticClass: "fa fa-walking" })]
                )
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c("UserPresenceModal", { ref: "userPresenceModal" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }